import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";

export const Input = ({
  error,
  messageError,
  type,
  name,
  id,
  value,
  onChange,
  placeholder,
}) => {
  return (
    <>
      <input
        value={value}
        onChange={onChange}
        name={name}
        id={id}
        placeholder={placeholder}
        className={clsx(
          error
            ? "border-[#F04438] focus:outline-[#F04438] focus:outline-double focus:outline-1 focus:ring-4 focus:ring-[#FECDCA]"
            : "focus:outline-[#0074E6] focus:outline-double focus:outline-1 focus:ring-4 focus:ring-[#BCDBFB] ",
          "h-[45px] px-[10px] border border-gray-cool-300 rounded-md text-base"
        )}
      />
      {error ? (
        <h6 className="text-[#F04438] font-inter text-sm pt-2">
          {messageError}
        </h6>
      ) : (
        ""
      )}
    </>
  );
};

export const PhoneNumberInput = ({
  error,
  messageError,
  type,
  name,
  id,
  value,
  onChange,
  placeholder,
  country,
  focus,
  phoneInputRef,
}) => {
  const [focused, setfocused] = useState(false);

  return (
    <>
      {/* <div className="relative flex w-full flex-col "> */}
      {/* <div
          className={clsx(
            "absolute flex items-center font-lexend px-3 w-full h-[45px] rounded-[5px] border-[1px]",
            error
              ? "border-[#F04438] focus:outline-[#F04438] focus:outline-double focus:outline-1 focus:ring-4 focus:ring-[#FECDCA]"
              : "border-[#cacaca] focus:outline-[#0074E6] focus:outline-double focus:outline-1 focus:ring-4 focus:ring-[#BCDBFB]"
          )}
        > */}
      <PhoneInput
        specialLabel={""}
        country={country ? country.toLowerCase() : "au"}
        defaultCountry={country ? country.toLowerCase() : "au"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        limitMaxLength={true}
        inputStyle={{
          width: "100%",
          height: "45px",
          ":focus": {
            borderColor: "#0074E6",
            boxShadow: "0px 0px 0px 1px #BCDBFB",
          },
          border: `${error ? "1px solid #F04438" : ""}`,
        }}
        onFocus={(e) => {
          console.log("ACS ", e), setfocused(true);
        }}
        onBlur={() => setfocused(false)}
        className={
          error && focused ? "focusError" : focused ? "focusDefault" : ""
        }
      />
      {/* </div> */}
      {/* </div> */}
      {error ? (
        <h6 className="text-[#F04438] font-inter text-sm relative -top-5">
          {messageError}
        </h6>
      ) : (
        ""
      )}
    </>
  );
};
